<template>
  <AgentPermissions
    :permissions="translatedPermissions"
    :title="title"
    @change="changePermission"
    @selectAll="changeAll(true)"
    @deselectAll="changeAll(false)"
  />
</template>

<script>
import cloneDeep from 'lodash.clonedeep';
import AgentPermissions from './AgentPermissions';
import {
  translateAppPermission,
  translatePermissionCategory,
} from './utils/permissionsTranslators';

export default {
  name: 'AgentAppPermissions',
  components: {
    AgentPermissions,
  },
  model: {
    prop: 'permissions',
    event: 'input',
  },
  props: {
    permissions: {
      required: true,
      type: Object,
    },
    selectedApp: {
      required: true,
      type: String,
    },
  },
  computed: {
    appPermissions() {
      return this.permissions.app_permissions;
    },
    title() {
      return translatePermissionCategory('app_permissions');
    },
    translatedPermissions() {
      const result = [];

      for (const [name, value] of Object.entries(this.appPermissions)) {
        const permissionTexts = translateAppPermission(name);

        if (!permissionTexts) continue;

        result.push({
          title: permissionTexts.title,
          description: permissionTexts.description,
          value: value.has(this.selectedApp),
          property: name,
        });
      }

      return result;
    },
  },
  methods: {
    changePermission({ property, value }) {
      const clonedPermissions = cloneDeep(this.permissions);
      if (value) {
        clonedPermissions.app_permissions[property].add(this.selectedApp);
      } else {
        clonedPermissions.app_permissions[property].delete(this.selectedApp);
      }
      this.submitChange(clonedPermissions);
    },
    changeAll(val) {
      const clonedPermissions = cloneDeep(this.permissions);
      Object.keys(clonedPermissions.app_permissions).forEach(perm => {
        if (val) clonedPermissions.app_permissions[perm].add(this.selectedApp);
        else clonedPermissions.app_permissions[perm].delete(this.selectedApp);
      });
      this.submitChange(clonedPermissions);
    },
    submitChange(permissions) {
      this.$emit('input', permissions);
    },
  },
};
</script>
